import { apiRequest } from '../utils/useAPIRequest';
import { appStore } from '../stores';
import constant from '../utils/constant';

const beneficiaries = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/banking/beneficiaries/business',
		method: 'get',
	});

	if (status === constant.Success) {
		const beneficiaries = data.beneficiaries.map(beneficiary => {
			return {
				key: beneficiary._id,
				value: {
					accountName: beneficiary.accountName,
					accountNumber: beneficiary.accountNumber,
					bankName: beneficiary.bankName,
					bankCode: beneficiary.bankCode,
				},
			};
		});
		appStore.setBeneficiaries(beneficiaries);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const BlogController = {
	beneficiaries,
};

export default BlogController;
